import {
  issuerConfigConstants,
  nameSpace
} from "../constants/issuerConfig.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const deleteIssuerConfig = (state = initialState, action) => {
  switch (action.type) {
    case issuerConfigConstants[`DELETE_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case issuerConfigConstants[`DELETE_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case issuerConfigConstants[`DELETE_${nameSpace}_FAILURE`]:
      return {
        ...state,
        loading: false,
        success: false,
        response: null,
        error: action.error
      };
    case issuerConfigConstants[`DELETE_${nameSpace}_RESET`]:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
